import React from 'react';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Card, CardContent, Typography, Button, List, ListItem, Box, CardMedia, styled } from '@mui/material';

const StyledCard = styled(Card)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  boxShadow: 3,
  borderRadius: theme.shape.borderRadius,
  [theme.breakpoints.down('sm')]: { // Adjust for small devices
    flexDirection: 'column', // Stack items vertically on small screens
  },
}));

const InfoSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  height: '100%',
  [theme.breakpoints.down('sm')]: {
    height: 'auto', // Adjust height for small devices
  },
}));

const PortfolioRetentionCard = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <StyledCard>
      <Box sx={{ display: 'flex', flexDirection: 'column', padding: 2 }}>
        <Typography gutterBottom variant="h5" component="div">
          PORTFOLIO RETENTION
        </Typography>
        <Typography gutterBottom variant="subtitle1" component="div">
          TRANSFORM LEADS TO TRANSACTIONS
        </Typography>
        <CardMedia
          component="img"
          image="/assets/portfolioscreenshot.jpg"
          alt="Snapshot of our tool"
          sx={{
            width: isSmallScreen ? '100%' : 'auto', // Adjust image width on small screens
            height: 'auto',
            borderRadius: '10%',
            marginBottom: 2
          }}
        />
      </Box>
      <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        flex: '1 0 auto',
        paddingTop: isSmallScreen ? 2 : 14, // Adjust padding top on small screens
      }}>
        <CardContent sx={{ flex: '1 0 auto', padding: 0, '&:last-child': { paddingBottom: 0 } }}>
        <Typography variant="body2" color="text.primary" paragraph>
            The average consumer will get over 6 loans over the course of their lifetime...
          </Typography>
          <Typography variant="body2" color="text.primary" paragraph>
            Only 20% of consumers use the same lender.
          </Typography>
          <Typography variant="body2" color="text.primary" paragraph>
            Past clients offer reliability and quality that provide consistent results.
          </Typography>
          <List>
            <ListItem>On-Demand Pipeline Query</ListItem>
            <ListItem>Consumer Engagement</ListItem>
            <ListItem>Lead Routing</ListItem>
            <ListItem>Client Acquisition & Lead Management Portal</ListItem>
            <ListItem>Lead to Loan Conversion Tools</ListItem>
            <ListItem>KPI Dashboard</ListItem>
            <ListItem>Call Center Routing</ListItem>
          </List>
        </CardContent>
        {/* Button aligned to the bottom right */}
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', padding: 2 }}>
          <Button size="small" color="primary">
            LEARN MORE
          </Button>
        </Box>
      </Box>
    </StyledCard>
  );
};

export default PortfolioRetentionCard;
